import React from "react";
import ViewAmenities  from "./viewAmenities";

class ViewAmenitiesParent extends React.Component {
    render() {
        return <ViewAmenities />
    }
}
export default ViewAmenitiesParent;